// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalBody_root__2aa6Y"};